export default __webpack_public_path__ + "static/media/spc.9439b74b.png";